__turbopack_context__.v({
  "alphabetisedSection": "_2FISyG_alphabetisedSection",
  "glossary": "_2FISyG_glossary",
  "glossaryContainer": "_2FISyG_glossaryContainer",
  "sectionHeading": "_2FISyG_sectionHeading",
});
